module.exports = __webpack_public_path__ + "img/cabinet_pending_verification.0b7a519e.svg";